const LivingSituation = Object.freeze({
  RENT: 'RENT',
  RENT_FREE: 'RENT_FREE',
  OWNER: 'OWNER'
})

export default LivingSituation
